import script from "./NavigationBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationBar.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationBar.vue?vue&type=style&index=0&id=34f71988&lang=scss"

const __exports__ = script;

export default __exports__